import { FC } from "react";

interface UserAvatarProps {
  fullName?: string;
  profilePictureUrl?: string;
  className?: string;
}

const UserAvatar: FC<UserAvatarProps> = ({ 
  fullName, 
  profilePictureUrl, 
  className = "w-10 h-10" 
}) => {
  const initials = fullName?.charAt(0) || 'U';

  if (profilePictureUrl) {
    return (
      <div className={`${className} rounded-full overflow-hidden bg-[#2F80ED] flex items-center justify-center shrink-0`}>
        <img 
          src={profilePictureUrl} 
          alt={`${fullName}'s profile`}
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback to initials if image fails to load
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            target.nextElementSibling?.classList.remove('hidden');
          }}
        />
        <div className="hidden w-full h-full bg-[#2F80ED] rounded-full flex items-center justify-center text-white font-medium text-sm">
          {initials}
        </div>
      </div>
    );
  }

  return (
    <div className={`${className} bg-[#2F80ED] rounded-full flex items-center justify-center text-white font-medium text-sm shrink-0`}>
      {initials}
    </div>
  );
};

export default UserAvatar;